import { z } from 'zod/v4'

// ***
// SCHEMAS
// ***

export const ClubResourceSchema = z.object({
  club: z.string(),
  hash: z.string(),
  name: z.string(),
  locale: z.string(),
})

// ***
// EXPORTED TYPES
// ***

export type ClubResource = z.infer<typeof ClubResourceSchema>
